import { render, staticRenderFns } from "./detection-package-form.vue?vue&type=template&id=479cc007&"
import script from "./detection-package-form.vue?vue&type=script&lang=js&"
export * from "./detection-package-form.vue?vue&type=script&lang=js&"
import style0 from "./detection-package-form.vue?vue&type=style&index=0&lang=less&"
import style1 from "./detection-package-form.vue?vue&type=style&index=1&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports